import { type EventCallback, RiveFile } from "@rive-app/canvas";

export const loadAndCacheRiveFile = (
  src: string,
  onSuccess: (file: RiveFile) => void,
  onError: EventCallback,
) => {
  const file = new RiveFile({
    src: src,
    onLoad: () => onSuccess(file),
    onLoadError: onError,
  });
  //Trigger the load
  file.init().catch(onError);
};
